import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { getUser, logout } from "../slices/authSlice";

const GameHub = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);
    const userProfileInfo = useAppSelector((state) => state.auth.userProfileData);

    useEffect(() => {
        if (basicUserInfo) {
            dispatch(getUser(basicUserInfo.id));
        }
    }, [basicUserInfo, dispatch]);

    const handleLogout = async () => {
        try {
            await dispatch(logout()).unwrap();
            navigate("/home");
        } catch (e) {
            console.error(e);
        }
    };

    const goToGame = () => {
        navigate("/game");
    };

    const tumBlue = "#0066B1";
    const tumBlueDark = "#004C87";

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #1a1a1a 0%, #2f2f2f 100%)",
                color: "#eee",
                fontFamily: "'Montserrat', sans-serif",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
                textAlign: "center",
            }}
        >
            <h2
                style={{
                    fontFamily: "'Crimson Text', serif",
                    fontSize: "3rem",
                    marginBottom: "0.5rem",
                    color: tumBlue,
                    letterSpacing: "0.05em",
                    textShadow: `0 0 10px ${tumBlue}`,
                }}
            >
                Willkommen, {userProfileInfo?.name || "Detektiv"}
            </h2>

            <div
                onClick={goToGame}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === "Enter" && goToGame()}
                style={{
                    cursor: "pointer",
                    maxWidth: 400,
                    width: "90%",
                    backgroundColor: tumBlue,
                    borderRadius: "1rem",
                    padding: "1.5rem",
                    marginTop: "2rem",
                    transition: "transform 0.3s ease, boxShadow 0.3s ease",
                    color: "#fff",
                    fontWeight: "600",
                    userSelect: "none",
                    boxShadow: `
            0 0 12px ${tumBlue}, 
            0 0 30px ${tumBlue}, 
            0 0 40px ${tumBlueDark}
        `,
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = `0 0 30px ${tumBlueDark}`;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = `0 0 12px ${tumBlue}, 
            0 0 30px ${tumBlue}, 
            0 0 40px ${tumBlueDark}
        `;
                }}
            >
                <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.8rem" }}>🗂️ Fallakte öffnen</h3>
                <p style={{ margin: 0, fontSize: "1.1rem", fontWeight: "400" }}>
                    Klicke hier, um dein nächstes Abenteuer zu starten.
                </p>
            </div>

            <button
                onClick={handleLogout}
                style={{
                    marginTop: "3.5rem",
                    padding: "0.75rem 3rem",
                    fontSize: "1.2rem",
                    fontWeight: "700",
                    borderRadius: "9999px",
                    border: `2px solid ${tumBlue}`,
                    backgroundColor: "transparent",
                    color: tumBlue,
                    cursor: "pointer",
                    boxShadow: `0 0 12px rgba(0, 102, 177, 0.6)`,
                    transition: "all 0.3s ease",
                    userSelect: "none",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = tumBlue;
                    e.currentTarget.style.color = "#fff";
                    e.currentTarget.style.boxShadow = "0 0 20px #004C87";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = tumBlue;
                    e.currentTarget.style.boxShadow = `0 0 12px rgba(0, 102, 177, 0.6)`;
                }}
            >
                Logout
            </button>
        </div>
    );
};

export default GameHub;
